// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-3d923896]{align-items:center;border-radius:6px;display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./resources/js/components/Icons/MessengerIconBase.vue"],"names":[],"mappings":"AACA,0BAGE,kBAAA,CACA,iBAAA,CAHA,YAAA,CACA,sBAEA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
